import React, {Suspense, lazy} from "react";
import {Redirect, Switch, Route} from "react-router-dom";
import {LayoutSplashScreen, ContentRoute} from "../_metronic/layout";
import {BuilderPage} from "./pages/BuilderPage";
import {MyPage} from "./pages/MyPage";
import {DashboardPage} from "./pages/DashboardPage";
import SalePage from "./modules/Sale/pages/SalePage";
import {ToastProvider} from "../_metronic/layout/_core/ToastProvider";
import {useSelector} from "react-redux";
import ReportsPage from "./modules/Reports/Pages/ReportsPage";
import AccountingPage from "./modules/Accounting/Pages/AccountingPage";
import OperationPage from "./modules/Operation/pages/OperationPage";
import QCPage from "./modules/QC/Pages/QCPage";
import UserProfilePage from "./modules/UserProfile/UserProfilePage";
import {PaymentPage} from "./pages/PaymentPage";

const SystemBasePage = lazy(() =>
    import("./modules/Base/pages/SystemBasePage")
)


export default function BasePage() {
    // useEffect(() => {
    //   console.log('Base page');
    // }, []) // [] - is required if you need only one call
    // https://reactjs.org/docs/hooks-reference.html#useeffect

    const {user} = useSelector(state => state.auth);

    return (
        <Suspense fallback={<LayoutSplashScreen/>}>
            <Switch>

                <Redirect to={'/dashboard'} exact from='/'/>
                
                <ContentRoute path="/dashboard" component={DashboardPage}/>
                <ContentRoute path="/builder" component={BuilderPage}/>
                <ContentRoute path="/payment" component={PaymentPage}/>
                <ContentRoute path="/my-page" component={MyPage}/>
                <Route path="/base" component={SystemBasePage}/>
                <Route path={"/reports"} component={ReportsPage}/>
                <Route path={"/sales"} component={SalePage}/>
                <Route path={"/accounting"} component={AccountingPage}/>
                <Route path={"/operation"} component={OperationPage}/>
                <Route path={"/QC"} component={QCPage}/>
                <Route path={"/user-profile"} component={UserProfilePage}/>/
                <Redirect to="error/error-v1"/>
            </Switch>
        </Suspense>
    );
}
